import { render, staticRenderFns } from "./exam_corp_detail.vue?vue&type=template&id=110353c4&scoped=true&"
import script from "./exam_corp_detail.vue?vue&type=script&lang=js&"
export * from "./exam_corp_detail.vue?vue&type=script&lang=js&"
import style0 from "./exam_corp_detail.vue?vue&type=style&index=0&id=110353c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110353c4",
  null
  
)

export default component.exports